import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ITicketTableRef } from '../constants/ticketlist.interface';
import { useApiHandler } from '../hooks/useApiHandler';
import { refreshTicketList } from '../constants/ticketlist.utils';

export const useResultsSection = props => {
    const { onAddWatchersOpen, onBulkReassignTicketOpen, onBulkReassignTicketClose } = props;

    const dispatch = useDispatch();
    const { bulkReassignmentUsersAPI, updateWatchersApi, defaultListAPI, filteredListAPI, listAPI } = useApiHandler();
    const {
        user: { userId },
    } = useSelector((state: any) => state.common.environment);
    const { listApiType } = useSelector((state: any) => state.ticketMgmt.ticketsList) || {};

    const tableRef = useRef<ITicketTableRef>(null);
    const [selectedRows, setSelectedRows] = useState([]);

    const resetSelection = useCallback(() => {
        if (tableRef.current) {
            tableRef.current.resetSelection();
        }
    }, []);

    const handleAddWatcherModal = () => {
        onAddWatchersOpen();
    };

    const onRowSelect = useCallback((selectedRows: any) => {
        setSelectedRows(selectedRows.map((row: any) => row.id));
    }, []);

    const handleBulkReassign = async () => {
        onBulkReassignTicketOpen();
        await bulkReassignmentUsersAPI(dispatch, {});
    };

    const handleBulkReassignTicketClose = useCallback(() => {
        onBulkReassignTicketClose();
        resetSelection();
    }, [onBulkReassignTicketClose]);

    const handleUpdateTicket = async isWatching => {
        const payload = {
            ticketIds: selectedRows,
            userIds: [userId],
            watch: isWatching,
        };
        await updateWatchersApi(dispatch, payload);
        refreshTicketList({
            dispatch,
            listApiType,
            defaultListAPI,
            listAPI,
            filteredListAPI,
        });
        resetSelection();
    };

    return {
        handleAddWatcherModal,
        selectedRows,
        onRowSelect,
        handleBulkReassign,
        handleBulkReassignTicketClose,
        tableRef,
        handleUpdateTicket,
        resetSelection,
    };
};
